(function () {
  'use strict';

  var TOTAL_STEPS = 5;

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('btl:fit_finder_' + name, data || {});
      }
    } catch (error) {
      // Analytics must never interrupt the shopping experience.
    }
  }

  function readSaved(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function save(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // The selector remains fully functional when storage is unavailable.
    }
  }

  function initFitFinder(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var sectionId = root.dataset.sectionId || 'default';
    var storageKey = 'btlFitFinder:' + sectionId;
    var form = root.querySelector('[data-fit-form]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-fit-step]'));
    var progressWrap = root.querySelector('[data-progress-wrap]');
    var progressBar = root.querySelector('[data-progress-bar]');
    var progressCopy = root.querySelector('[data-progress-copy]');
    var result = root.querySelector('[data-fit-result]');
    var resultMount = root.querySelector('[data-result-mount]');
    var missing = root.querySelector('[data-fit-missing]');
    var saved = readSaved(storageKey);
    var currentStep = 0;
    var defaultState = {
      weight: '',
      behaviour: '',
      mobility: '',
      litter: '',
      shape: ''
    };
    var state = Object.assign({}, defaultState, saved && saved.answers ? saved.answers : {});

    function fieldNameForStep(index) {
      return ['weight', 'behaviour', 'mobility', 'litter', 'shape'][index];
    }

    function restoreInputs() {
      Object.keys(state).forEach(function (name) {
        if (!state[name]) return;
        var input = form.querySelector('input[name="' + name + '"][value="' + state[name] + '"]');
        if (input) input.checked = true;
      });
    }

    function updateNextButton(index) {
      var step = steps[index];
      if (!step) return;
      var next = step.querySelector('[data-next]');
      if (!next) return;
      next.disabled = !state[fieldNameForStep(index)];
    }

    function showStep(index, moveFocus) {
      currentStep = Math.max(0, Math.min(index, TOTAL_STEPS - 1));
      steps.forEach(function (step, stepIndex) {
        step.hidden = stepIndex !== currentStep;
      });
      result.hidden = true;
      missing.hidden = true;
      progressWrap.hidden = false;
      progressBar.style.width = (((currentStep + 1) / TOTAL_STEPS) * 100) + '%';
      progressBar.parentElement.setAttribute('aria-valuenow', String(currentStep + 1));
      progressCopy.textContent = 'Step ' + (currentStep + 1) + ' of ' + TOTAL_STEPS;
      updateNextButton(currentStep);

      if (moveFocus) {
        var heading = steps[currentStep].querySelector('[data-step-heading]');
        if (heading) heading.focus({ preventScroll: true });
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function recommendationKey() {
      var size = state.weight === 'over_7' ? 'xxl' : 'regular';
      var shape = state.shape === 'round' || state.shape === 'rectangle' ? state.shape : '';

      // Pellet compatibility and the >7 kg XXL rule are hard constraints.
      if (state.litter === 'wood_pellets') return size + '_pellet';
      if (state.litter === 'clumping' && root.dataset.preferClumpingSieve === 'true') {
        return size + '_clumping';
      }
      if (state.mobility === 'limited') return shape ? size + '_' + shape + '_mobility' : size + '_mobility';
      if (state.behaviour === 'sprayer' || state.behaviour === 'both') {
        return shape ? size + '_' + shape + '_spray' : size + '_spray';
      }
      if (state.behaviour === 'digger') return shape ? size + '_' + shape + '_dig' : size + '_dig';
      return shape ? size + '_' + shape + '_default' : size + '_default';
    }

    function findTemplate(key) {
      var exact = root.querySelector('template[data-product-key="' + key + '"]');
      if (exact) return { key: key, template: exact };

      // Wood-pellet compatibility must not silently fall back to a non-sieve product.
      if (key.indexOf('_pellet') !== -1) return null;

      var size = state.weight === 'over_7' ? 'xxl' : 'regular';
      var shape = state.shape === 'round' || state.shape === 'rectangle' ? state.shape : '';
      var trait = key.split('_').slice(shape ? 2 : 1).join('_');
      var fallbackKeys = [];

      // Functional needs outrank shape when an exact combination is unavailable.
      if (trait && trait !== 'default') fallbackKeys.push(size + '_' + trait);
      if (shape) fallbackKeys.push(size + '_' + shape + '_default');
      fallbackKeys.push(size + '_default');

      for (var index = 0; index < fallbackKeys.length; index += 1) {
        var fallbackKey = fallbackKeys[index];
        var fallback = root.querySelector('template[data-product-key="' + fallbackKey + '"]');
        if (fallback) return { key: fallbackKey, template: fallback };
      }
      return null;
    }

    function reasonsForMatch(renderedKey) {
      var reasons = [];

      if (state.weight === 'over_7') {
        reasons.push('Your cat is over 7 kg, so this recommendation comes from the XXL range.');
      } else if (state.weight === 'under_4') {
        reasons.push('Sized for a cat under 4 kg without forcing an unnecessarily large footprint.');
      } else if (state.weight === 'four_to_seven') {
        reasons.push('Selected for cats in the 4–7 kg range.');
      } else {
        reasons.push('A versatile size was selected because your cat’s weight is not known.');
      }

      if (state.mobility === 'limited') {
        reasons.push('Prioritises easier entry for a senior cat or a cat with limited mobility.');
        if (state.behaviour === 'sprayer' || state.behaviour === 'both') {
          reasons.push('Easy entry was prioritised over maximum spray containment; check the entry and wall dimensions before ordering.');
        } else if (state.behaviour === 'digger') {
          reasons.push('Easy entry was prioritised over maximum litter containment; adding a trapping mat may help with kicked litter.');
        }
      } else if (state.behaviour === 'sprayer') {
        reasons.push('Higher containment helps manage cats that spray above a standard tray.');
      } else if (state.behaviour === 'digger') {
        reasons.push('Extra containment helps keep vigorously kicked litter inside the box.');
      } else if (state.behaviour === 'both') {
        reasons.push('Chosen for both high spraying and enthusiastic digging.');
      } else {
        reasons.push('A balanced everyday design suits normal litter-box habits.');
      }

      if (state.litter === 'wood_pellets') {
        reasons.push('Compatible with a wood-pellet sieve system.');
      } else if (state.litter === 'clumping') {
        reasons.push('Suitable for clumping clay, tofu or similar clumping litter.');
      } else if (state.litter === 'crystal') {
        reasons.push('Suitable for crystal or other non-clumping litter.');
      } else {
        reasons.push('Works as the safest general match for an unknown or less common litter type.');
      }

      if (state.shape === 'round') {
        if (state.litter === 'wood_pellets') {
          reasons.push('Pellet-system compatibility was prioritised over the round preference.');
        } else if (renderedKey.indexOf('_round_') !== -1) {
          reasons.push('Uses the round format for cats that circle, turn and dig before settling.');
        } else {
          reasons.push('Your round preference was considered, but the stronger functional match took priority.');
        }
      } else if (state.shape === 'rectangle') {
        if (renderedKey.indexOf('_rectangle_') !== -1) {
          reasons.push('Uses the rectangular format for cats that stretch, walk and position themselves.');
        } else {
          reasons.push('Your rectangular preference was considered, but the stronger functional match took priority.');
        }
      } else {
        reasons.push('Shape was selected from your other answers because you chose no preference.');
      }

      return reasons;
    }

    function renderRecommendation(moveFocus) {
      var requestedKey = recommendationKey();
      var match = findTemplate(requestedKey);

      steps.forEach(function (step) { step.hidden = true; });
      progressWrap.hidden = true;
      result.hidden = false;
      resultMount.innerHTML = '';
      missing.hidden = true;

      if (!match) {
        missing.hidden = false;
        missing.textContent = state.litter === 'wood_pellets' && state.weight === 'over_7'
          ? 'We could not find a configured XXL product that is compatible with wood pellets. Please contact us so we can recommend a safe fit rather than sending you to a smaller box.'
          : 'This recommendation has not been configured yet. Please contact us and we’ll help you choose.';
        publish('no_match', {
          requested_key: requestedKey,
          weight: state.weight,
          behaviour: state.behaviour,
          mobility: state.mobility,
          litter: state.litter,
          shape: state.shape
        });
      } else {
        resultMount.appendChild(match.template.content.cloneNode(true));
        var list = resultMount.querySelector('[data-result-reasons]');
        reasonsForMatch(match.key).forEach(function (reason) {
          var item = document.createElement('li');
          item.textContent = reason;
          list.appendChild(item);
        });

        publish('recommendation_viewed', {
          requested_key: requestedKey,
          rendered_key: match.key,
          product_id: match.template.dataset.productId || '',
          weight: state.weight,
          behaviour: state.behaviour,
          mobility: state.mobility,
          litter: state.litter,
          shape: state.shape
        });
      }

      save(storageKey, { answers: state, complete: true });
      if (moveFocus) {
        var resultHeading = root.querySelector('[data-result-heading]');
        if (resultHeading) resultHeading.focus({ preventScroll: true });
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    form.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('input[type="radio"]')) return;
      state[input.name] = input.value;
      updateNextButton(currentStep);
      save(storageKey, { answers: state, complete: false });
      publish('answer_selected', {
        step: input.name,
        answer: input.value,
        step_number: currentStep + 1
      });
    });

    form.addEventListener('click', function (event) {
      var next = event.target.closest('[data-next]');
      var back = event.target.closest('[data-back]');

      if (next) {
        event.preventDefault();
        if (!state[fieldNameForStep(currentStep)]) return;
        publish('step_completed', {
          step: fieldNameForStep(currentStep),
          answer: state[fieldNameForStep(currentStep)],
          step_number: currentStep + 1
        });
        if (currentStep === TOTAL_STEPS - 1) {
          renderRecommendation(true);
        } else {
          showStep(currentStep + 1, true);
        }
      }

      if (back) {
        event.preventDefault();
        showStep(currentStep - 1, true);
      }
    });

    root.addEventListener('click', function (event) {
      var restart = event.target.closest('[data-restart]');
      var productLink = event.target.closest('[data-recommended-product-link]');

      if (restart) {
        event.preventDefault();
        state = { weight: '', behaviour: '', mobility: '', litter: '', shape: '' };
        form.reset();
        save(storageKey, { answers: state, complete: false });
        publish('restarted', {});
        showStep(0, true);
      }

      if (productLink) {
        publish('product_clicked', {
          product_id: productLink.dataset.productId || '',
          product_handle: productLink.dataset.productHandle || '',
          weight: state.weight,
          behaviour: state.behaviour,
          mobility: state.mobility,
          litter: state.litter,
          shape: state.shape
        });
      }
    });

    restoreInputs();
    publish('loaded', { source_path: window.location.pathname });
    if (saved && saved.complete && state.weight && state.behaviour && state.mobility && state.litter && state.shape) {
      renderRecommendation(false);
    } else {
      showStep(0, false);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-btl-fit-finder]').forEach(initFitFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
